(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prd-nav"] && !Shopify.designMode) return;
  try {
    
  class PrdNav extends HTMLElement {
    connectedCallback() {
      const toggle = this.querySelector('[data-prdnav-toggle]');
      const drawer = this.querySelector('[data-prdnav-drawer]');
      if (!toggle || !drawer) return;
      toggle.addEventListener('click', () => {
        const open = drawer.hasAttribute('data-open');
        if (open) { drawer.removeAttribute('data-open'); drawer.hidden = true; }
        else { drawer.setAttribute('data-open', ''); drawer.hidden = false; }
      });
    }
  }
  if (!customElements.get('prd-nav')) customElements.define('prd-nav', PrdNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sum-nav"] && !Shopify.designMode) return;
  try {
    
  class SumNav extends HTMLElement {
    connectedCallback() {
      const t = this.querySelector('[data-sumnav-toggle]');
      const d = this.querySelector('[data-sumnav-drawer]');
      if (!t || !d) return;
      t.addEventListener('click', () => {
        if (d.hasAttribute('data-open')) { d.removeAttribute('data-open'); d.hidden = true; }
        else { d.setAttribute('data-open', ''); d.hidden = false; }
      });
    }
  }
  if (!customElements.get('sum-nav')) customElements.define('sum-nav', SumNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-chips"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__tchipsInit) return;
  window.__tchipsInit = true;

  var cache = {};
  var lastPath = location.pathname;
  var token = 0;

  function fetchDoc(url) {
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          return r.text();
        })
        .then(function (t) { return new DOMParser().parseFromString(t, 'text/html'); });
      cache[url].catch(function () { delete cache[url]; });
    }
    return cache[url];
  }

  function sections(root) {
    return Array.prototype.slice.call(root.querySelectorAll('#MainContent > .shopify-section'));
  }
  function chipsIndex(list) {
    for (var i = 0; i < list.length; i++) if (list[i].querySelector('.tchips')) return i;
    return -1;
  }

  function shuffleGrid(grid) {
    var items = Array.prototype.filter.call(grid.children, function (el) { return el.tagName === 'LI'; });
    if (items.length < 3) return;
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
    }
    var frag = document.createDocumentFragment();
    items.forEach(function (el) { frag.appendChild(el); });
    grid.appendChild(frag);
  }

  function markActive(url) {
    var u = new URL(url, location.href).pathname;
    document.querySelectorAll('.tchips__chip').forEach(function (c) {
      c.classList.toggle('is-active', new URL(c.href, location.href).pathname === u);
    });
  }

  function swap(doc, url) {
    var main = document.getElementById('MainContent');
    var newMain = doc.getElementById('MainContent');
    if (!main || !newMain) return false;
    var oldS = sections(main), newS = sections(newMain);
    var oi = chipsIndex(oldS), ni = chipsIndex(newS);
    if (oi < 0 || ni < 0) return false;

    var chips = oldS[oi];
    var newChips = newS[ni].querySelectorAll('.tchips__chip');
    var oldChips = chips.querySelectorAll('.tchips__chip');
    if (newChips.length === oldChips.length) {
      oldChips.forEach(function (c, i) { c.classList.toggle('is-active', newChips[i].classList.contains('is-active')); });
    }

    main.style.minHeight = main.offsetHeight + 'px';
    oldS.forEach(function (s, i) { if (i !== oi) s.remove(); });

    var after = chips;
    newS.forEach(function (s, i) {
      if (i === ni) return;
      var el = document.importNode(s, true);
      el.classList.add('tchips-enter');
      if (i < ni) chips.before(el);
      else { after.after(el); after = el; }
    });

    var target = new URL(url, location.href);
    var nav = chips.querySelector('.tchips');
    var allPath = nav ? nav.getAttribute('data-all-path') : '';
    if (allPath && target.pathname === allPath && !target.search) {
      var grid = document.querySelector('.product-grid');
      if (grid) shuffleGrid(grid);
    }

    document.title = doc.title;
    requestAnimationFrame(function () { main.style.minHeight = ''; });

    var top = chips.getBoundingClientRect().top;
    if (top < 70) window.scrollTo(0, window.scrollY + top - 80);
    return true;
  }

  function go(url, push) {
    var main = document.getElementById('MainContent');
    if (!main) { location.href = url; return; }
    var my = ++token;
    markActive(url);
    sections(main).forEach(function (s) {
      if (!s.querySelector('.tchips')) s.classList.add('tchips-dim');
    });
    fetchDoc(url)
      .then(function (doc) {
        if (my !== token) return;
        if (!swap(doc, url)) throw new Error('swap');
        if (push) history.pushState({ tchips: 1 }, '', url);
        lastPath = location.pathname;
      })
      .catch(function () {
        if (my === token) location.href = url;
      });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.tchips__chip');
    if (!a) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if (a.href === location.href) return;
    go(a.href, true);
  });

  function prefetch(e) {
    var a = e.target.closest && e.target.closest('.tchips__chip');
    if (a) fetchDoc(a.href).catch(function () {});
  }
  document.addEventListener('pointerover', prefetch);
  document.addEventListener('touchstart', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch);

  window.addEventListener('popstate', function () {
    if (!document.querySelector('.tchips')) return;
    if (location.pathname === lastPath) return;
    go(location.href, false);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class VideoReviews extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('[data-vr-stage]');
        if (!this.stage) return;
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-vr-slide]'));
        if (!this.slides.length) return;
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-vr-dot]'));
        this.index = 0;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduce;
        this.muted = true;

        var prev = this.querySelector('[data-vr-prev]');
        var next = this.querySelector('[data-vr-next]');
        if (prev) prev.addEventListener('click', function () { this.go(this.index - 1); }.bind(this));
        if (next) next.addEventListener('click', function () { this.go(this.index + 1); }.bind(this));

        var self = this;
        this.querySelectorAll('[data-vr-go]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var i = parseInt(btn.getAttribute('data-vr-go'), 10);
            if (i === self.index) { self.togglePlay(); } else { self.go(i); }
          });
        });
        this.dots.forEach(function (d) {
          d.addEventListener('click', function () { self.go(parseInt(d.getAttribute('data-vr-dot'), 10)); });
        });
        this.querySelectorAll('[data-vr-sound]').forEach(function (b) {
          b.addEventListener('click', function (e) { e.stopPropagation(); self.toggleSound(); });
        });

        this.setAttribute('tabindex', '0');
        this.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1); }
        });

        var x0 = null;
        this.stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        this.stage.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) { self.go(self.index + (dx < 0 ? 1 : -1)); }
          x0 = null;
        }, { passive: true });

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (!en.isIntersecting) { self.pauseAll(); }
              else if (self.autoplay) { self.playActive(); }
            });
          }, { threshold: 0.25 });
          this.io.observe(this);
        }

        this.render();
        if (this.autoplay) this.playActive();
      }

      go(i) {
        var n = this.slides.length;
        this.index = ((i % n) + n) % n;
        this.render();
        if (this.autoplay) this.playActive();
      }

      render() {
        var self = this;
        this.slides.forEach(function (s, i) {
          var d = i - self.index;
          s.classList.toggle('is-active', d === 0);
          s.classList.toggle('is-prev', d === -1);
          s.classList.toggle('is-next', d === 1);
          s.classList.toggle('is-far', Math.abs(d) > 1);
          s.style.setProperty('--vr-offset', d);
        });
        this.dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === self.index); });
      }

      activeVideo() {
        return this.slides[this.index] ? this.slides[this.index].querySelector('[data-vr-video]') : null;
      }

      pauseAll() {
        this.querySelectorAll('[data-vr-video]').forEach(function (v) { try { v.pause(); } catch (e) {} });
      }

      playActive() {
        this.pauseAll();
        var v = this.activeVideo();
        if (!v) return;
        v.muted = this.muted;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }

      togglePlay() {
        var v = this.activeVideo();
        if (!v) return;
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      }

      toggleSound() {
        this.muted = !this.muted;
        var v = this.activeVideo();
        if (v) {
          v.muted = this.muted;
          if (!this.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        }
        this.querySelectorAll('[data-vr-sound]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(!this.muted));
        }.bind(this));
        this.classList.toggle('vr-sound-on', !this.muted);
      }
    }
    if (!customElements.get('video-reviews')) customElements.define('video-reviews', VideoReviews);
  })();

  } catch(e) { console.error(e); }
})();
})();
